<template>
  <v-container
    id="notas-fiscais-form"
    fluid
    tag="section"
  >
    <!-- FORMULARIO DE USUARIO NAO IDENTIFICADO ------------------------------------------------->
    <usuario-nao-identificado-form
      v-if="!usuarioIdentificado"
      :titulocard="$t('notas-fiscais')"
    />

    <base-material-card
      v-else
      color="primary"
      icon="mdi-note-text"
      :title="$t('notas-fiscais')"
      :app-online="appOnline"
    >
      <!-- FILTRO -------------------------------------------------------------------------------->
      <v-skeleton-loader
        v-if="loading_laticinios"
        type="table-heading, table-tbody, table-tfoot"
      />
      <v-row v-else>
        <v-col
          cols="12"
          sm="6"
          md="12"
        >
          <dashboard-core-filtro
            :lista-select="listaLaticinios"
            :selected-id="idLaticinio"
            :selected-date="dataFiltro"
            :filtrar-func="pesquisar"
            :disabled-select="disabledSelectLaticinio"
            :label-select="laticinioLabel"
            label-select-date="Período"
            @update-selected-id="updateSelectedId"
            @update-selected-date="updateSelectedDate"
          />
        </v-col>
      </v-row>

      <!-- DATATABLE DE NOTAS FISCAIS ------------------------------------------------------------>
      <v-skeleton-loader
        v-if="loading"
        height="250"
        type="table-tbody"
      />
      <v-data-table
        v-else
        :items="listaNotas"
        :items-per-page="5"
        :headers="titulosListaNotas"
        disable-pagination
        hide-default-footer
        disable-sort
      >
        <template v-slot:[`item.total`]="{ item }">
          <v-label class="primary--text">
            {{ parseMoeda(item.total,2) }}
          </v-label>
        </template>
        <template v-slot:[`item.dataemissao`]="{ item }">
          <v-label class="primary--text">
            {{ formatDiaMesAno(item.dataemissao) }}
          </v-label>
        </template>
        <template v-slot:[`item.id`]="{ item }">
          <v-btn
            class="px-2 ml-1"
            min-width="0"
            color="primary"
            @click="ExibeItensNota(item.id)"
          >
            Detalhar
          </v-btn>
        </template>
      </v-data-table>

      <!-- ITENS DA NOTAFISCAL ------------------------------------------------------------------->
      <itens-nota-form
        :nota="notaSelecionada"
        :itens-nota="listaItensNota"
        :empresa-nota="empresaNota"
        :exibe-dialog="dialog"
        @update-dialog="updateDialog"
      />

      <!-- SNACKBAR ------------------------------------------------------------------------------>
      <dashboard-core-snackbar
        v-model="snackbar.visible"
        :visible="snackbar.visible"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        :message="snackbar.message"
      />
    </base-material-card>
  </v-container>
</template>

<script>
  import NotasFiscaisService from '../../../services/notasfiscaisservice'
  import utils from '../../../services/utils'
  export default {
    name: 'DashboardFormsNotasFiscaisForm',

    components: {
      DashboardCoreSnackbar: () => import('../components/core/Snackbar'),
      DashboardCoreFiltro: () => import('../components/core/Filtro'),
      ItensNotaForm: () => import('../forms/ItensNotaForm'),
      UsuarioNaoIdentificadoForm: () => import('./UsuarioNaoIdentificadoForm'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      usuarioIdentificado: true,
      loading: false,
      dialog: false,
      loading_laticinios: false,
      disabledSelectLaticinio: false,
      idLaticinio: 0,
      idProdutor: 0,
      idNota: 0,
      laticinioLabel: 'Laticínio',
      listaLaticinios: [],
      listaNotas: [],
      listaItensNota: [],
      listaIntensNotas: [],
      titulosListaNotas: [
        { text: 'Número Nota', sortable: true, value: 'numeronota' },
        { text: 'Data Emissão', sortable: true, value: 'dataemissao' },
        { text: 'Valor', sortable: true, value: 'total' },
        { text: '', align: 'end', sortable: true, value: 'id' },
      ],
      dataFiltro: new Date().toISOString().substr(0, 10),
      laticinioSelecionado: {},
      notaSelecionada: {},
      empresaNota: {},
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
    }),

    mounted () {
      // this.verificaVersao()
      if (localStorage.chaveativacao && localStorage.chaveativacao !== 'undefined') {
        this.chaveativacao = localStorage.chaveativacao
        if (localStorage.getItem('usuarioIdentificado') && localStorage.getItem('usuarioIdentificado') === 'true') {
          this.usuarioIdentificado = true
          this.carregaForm()
        } else {
          this.usuarioIdentificado = false
        }
      } else {
        localStorage.clear()
        this.$router.push('/pages/usuarioprodutor')
      }
    },

    methods: {
      carregaForm () {
        this.idLaticinio = -1
        this.pesquisar()
      },

      pesquisar () {
        if (this.idLaticinio === -1) {
          this.carregaLaticinios()
        } else if (this.idLaticinio === 0) {
          this.showSnackbar('warning', 3000, 'Selecione um laticínio antes de pesquisar.')
        } else {
          this.dialog = false
          this.carregaNotasFiscais()
        }
      },
      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
      updateSelectedId (selectedId) {
        this.idLaticinio = selectedId
      },
      updateSelectedDate (selectedDate) {
        this.dataFiltro = selectedDate
      },
      updateDialog (dialog) {
        this.dialog = dialog
      },
      carregaLaticinios () {
        this.idLaticinio = 0
        this.loading_laticinios = true
        NotasFiscaisService.listarLaticinios(localStorage.chaveativacao).then(resposta => {
          if (resposta.data.empresas.length > 0) {
            this.listaLaticinios = resposta.data.empresas
            this.idProdutor = resposta.data.empresas[0].produtor_id
            if (resposta.data.empresas.length === 1) {
              this.idLaticinio = resposta.data.empresas[0].id
              this.laticinioSelecionado = resposta.data.empresas[0]
              this.laticinioLabel = resposta.data.empresas[0].nome
              this.disabledSelectLaticinio = true
              this.carregaNotasFiscais()
              // this.empresaDoRecibo = this.listaLaticinios.find((item) => item.id === this.idLaticinio)
            }
          }
          this.loading_laticinios = false
          this.disabledSelectDate = false
          this.verificaVersao(resposta.data.versao_vue)
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            this.carregaDadosOffline()
          } else {
            console.log('Erro listarLaticinios(): ' + e.response)
            this.$router.push('/')
          }
          this.loading_laticinios = false
        })
      },
      carregaNotasFiscais () {
        this.loading = true
        var primeiroDiaDoMes = this.getFirstDayOfMonth(this.dataFiltro)
        var laticinio = this.listaLaticinios.find(item => item.id === this.idLaticinio)
        NotasFiscaisService.listarNotasFiscais(this.idLaticinio, laticinio.produtor_id, primeiroDiaDoMes).then(resposta => {
          this.appOnline = true
          this.listaNotas = resposta.data.notas
          this.listaItensNotas = resposta.data.itens_notas

          this.loading = false
          // this.calculaTotais()
          if (this.listaNotas.length > 0) {
            this.salvaDadosOffline()
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            this.carregaDadosOffline()
          } else {
            console.log('Erro listar(): ' + e.response)
            this.$router.push('/')
          }
          this.loading = false
        })
      },
      ExibeItensNota (idNota) {
        /* obter da lista o item selecionado e obter as informações desse item */
        this.notaSelecionada = this.listaNotas.find(item => item.id === idNota)
        this.empresaNota = this.notaSelecionada.empresa

        // Ao inves de buscar pelo id na api vai apenas buscar na lista com todos os itens de recibo desse produtor
        this.listaItensNota = this.listaItensNotas.filter(item => item.notaFiscal.id === idNota)
        this.dialog = true
      },
      salvaDadosOffline () {
        try {
          localStorage.laticinioSelecionadoNotasFiscais = this.laticinioLabel
          localStorage.mesSelecionadoNotasFiscais = this.selectedDate
          const parsed1 = JSON.stringify(this.listaNotas)
          localStorage.setItem('listaNotasFiscais', parsed1)
          const parsed2 = JSON.stringify(this.listaItensNotas)
          localStorage.setItem('listaItensNotasFiscais', parsed2)
        } catch (e) {
        }
      },
      carregaDadosOffline () {
        this.appOnline = false
        this.laticinioLabel = localStorage.laticinioSelecionadoNotasFiscais
        this.date = localStorage.mesSelecionadoNotasFiscais
        this.disabledSelectLaticinio = true
        this.disabledSelectDate = true
        if (localStorage.getItem('listaNotasFiscais')) {
          try {
            this.listaNotas = JSON.parse(localStorage.getItem('listaNotasFiscais'))
            this.listaItensNotas = JSON.parse(localStorage.getItem('listaItensNotasFiscais'))
          } catch (e) {
            localStorage.removeItem('listaNotasFiscais')
            localStorage.removeItem('listaItensNotasFiscais')
          }
        }
      },
    },
  }
</script>

<style scoped>
  .quitado { color: green; }
  .cancelado { color: red; }
  .totalizador { background-color: rgba(78, 119, 173, 0.2);}
  .totalizador td { font-weight: 500;}
  .v-data-table table thead tr th {font-weight: 400;}
  .theme--light.v-label {
    color: rgba(0, 0, 0, 0.7);
}
</style>
